export const environment = {
  server: {
    url: 'https://api.cpastorm.network'
  },
  dsn: 'https://05c791866a1f49f28b6bcfd60f7b482c@glitchtip.zyncotech.com/5'
}
